var _defs, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetiredRoomsBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1900 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 815.3,
    y1: 132.29,
    x2: 478.9,
    y2: 215.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#96d82a",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6f9f2a",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#4f702a",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#364b2a",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#23312a",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#18212a",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#151c2b",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 812.73,
    y1: 95.45,
    x2: 588.03,
    y2: 252.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#96d82a",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#6f9f2a",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#4f702a",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#364b2a",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#23312a",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#18212a",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#151c2b",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 866.82,
    y1: 104.78,
    x2: 645.01,
    y2: 272.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#96d82a",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6f9f2a",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#4f702a",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#364b2a",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#23312a",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#18212a",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#151c2b",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 962.87,
    y1: 122.96,
    x2: 702.06,
    y2: 320.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#87c22a",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#577c2a",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#34482a",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#1e282a",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#161d2b",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#151c2b",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -8537.06,
    cy: -7988.15,
    fx: -8537.06,
    fy: -7988.15,
    r: 3.63,
    gradientTransform: "translate(4502.96 -5650.68) rotate(-15.97) scale(.58 -.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bc81e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -8542.16,
    cy: 7478.05,
    fx: -8542.16,
    fy: 7478.05,
    r: 9.23,
    gradientTransform: "translate(4577.76 -5389.33) rotate(-15.97) scale(.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -8534.13,
    cy: -7945.15,
    fx: -8534.13,
    fy: -7945.15,
    r: 28.45,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -8521.03,
    cy: 7506.02,
    fx: -8521.03,
    fy: 7506.02,
    r: 9.23,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 1014.24,
    cy: 212.58,
    fx: 1014.24,
    fy: 212.58,
    r: 17.07,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -8538.98,
    cy: 7478.48,
    fx: -8538.98,
    fy: 7478.48,
    r: 9.23,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -7940.31,
    cy: -11474.36,
    fx: -7940.31,
    fy: -11474.36,
    r: 3.63,
    gradientTransform: "translate(7316.71 -5026.55) rotate(15.54) scale(.58 -.58)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: -7945.41,
    cy: 10964.26,
    fx: -7945.41,
    fy: 10964.26,
    r: 9.23,
    gradientTransform: "translate(7243.89 -4764.63) rotate(15.54) scale(.58)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: -7937.39,
    cy: -11431.36,
    fx: -7937.39,
    fy: -11431.36,
    r: 28.45,
    gradientTransform: "translate(7316.71 -5026.55) rotate(15.54) scale(.58 -.58)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: -7924.28,
    cy: 10992.23,
    fx: -7924.28,
    fy: 10992.23,
    r: 9.23,
    gradientTransform: "translate(7243.89 -4764.63) rotate(15.54) scale(.58)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 1069.98,
    cy: 196.65,
    fx: 1069.98,
    fy: 196.65,
    r: 16.96,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: -7942.23,
    cy: 10964.7,
    fx: -7942.23,
    fy: 10964.7,
    r: 9.23,
    gradientTransform: "translate(7243.89 -4764.63) rotate(15.54) scale(.58)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 764.9,
    y1: 113.88,
    x2: 706.08,
    y2: 131.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#9ce12a",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8cc92a",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#71a22a",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4c6c2a",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1d282a",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#151c2b",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 817.26,
    y1: 120.69,
    x2: 738.72,
    y2: 131.09,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 891.88,
    y1: 145.85,
    x2: 777.5,
    y2: 95.02,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1000.94,
    y1: 143.5,
    x2: 855.1,
    y2: 114.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#a3ea2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#9add2a",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#72a32a",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#50722a",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#364d2a",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#24322a",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#19212a",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#151c2b",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.56,
    dy: 1.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1.83
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.56,
    dy: 1.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 1.83
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -61,
    y: -36.5,
    width: 1994,
    height: 355,
    style: {
      fill: "#151c2b"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "724.25 153.25 724.34 83.47 746.59 83.9 746.48 149.67 724.25 153.25",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "934.75 216.06 879.75 199.44 879.75 199.4 934.75 216.06",
    style: {
      fill: "#1c2538"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "758.65 163.74 786.29 157.14 785.4 83.02 759.74 76.67 758.65 163.74",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "810.5 178.97 845.6 167.85 846.19 71.07 810.5 67.71 810.5 178.97",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1041.42 247.45 1036.86 246.07 1036.86 34.19 1041.29 33.63 1041.42 247.45",
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "879.75 199.44 917.33 185.03 921.62 60.41 879.64 53.29 879.75 199.44",
    style: {
      fill: "#223654"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m750.95,161.11l3.49,1.31.3-84.03h-.77l-30.31,2.73-1.2,71.43,1.79.74m26.19,7.05l.97.26m-27.15-7.35l.09-69.79,27.83.39-.66,67.5-.02,2.25-.08,6.96-27.15-7.32Z",
    style: {
      fill: "#d4d8df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m800.19,70.37l-42.75,4.17-.47,88.56,1.68.64,39.59,11.11,2.44.8.66.22-1.15-105.49Zm-41.54,93.28l1.09-86.98,38.09-2.96.41,101.14-39.59-11.2Z",
    style: {
      fill: "#d4d8df"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "865.53 58.86 865.53 195.07 864.21 194.63 859.15 193.16 859.07 193.14 858.99 193.11 810.5 178.97 849.71 190.3 849.84 190.33 861.86 193.81 861.86 63.15 810.5 67.71 810.5 178.97 807.16 177.96 807.16 177.4 807.5 64.86 865.53 58.86",
    style: {
      fill: "#d4d8df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m875.72,49.75l-2.49,147.67,6.52,2.01,78.62,23.79h0s2.35-181.63,2.35-181.63l-85,8.16Zm4.03,149.65l-.11-146.11,75.72-6.41-3.14,174.47-17.48-5.29-55-16.66Z",
    style: {
      fill: "#d4d8df"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1117.9 24.65 999.67 38.94 997.46 235.06 986.9 231.87 989.49 33.63 1121.19 15.5 1111.31 270.57 1097.77 265.08 1108.75 25.75",
    style: {
      fill: "#d4d8df"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1097.77 265.08 997.46 234.61 999.67 39.38 1108.75 25.75 1097.77 265.08",
    style: {
      fill: "#212c42"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "724.52 153 508 191.5 556 212.5 751.42 160.54 751.41 158.91 752 149.5 724.52 153",
    style: {
      fill: "url(#linear-gradient)",
      opacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "758.65 163.65 541 216.5 596 236.5 798.24 174.85 798.24 171.75 798.24 154.48 758.65 163.65",
    style: {
      fill: "url(#linear-gradient-2)",
      opacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "810.14 179.08 584 233.5 636 270.5 861.74 193.72 810.14 179.08",
    style: {
      fill: "url(#linear-gradient-3)",
      opacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "879.75 199.4 635 280.5 780 318.5 952.22 221.35 879.75 199.4",
    style: {
      fill: "url(#linear-gradient-4)",
      opacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 744.4,
    cy: 120.11,
    r: 0.87,
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 781.7,
    cy: 119.45,
    r: 1.09,
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 842.55,
    cy: 119.24,
    r: 1.31,
    style: {
      fill: "#a3ea2a"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 913.21,
    cy: 122.45,
    r: 1.73,
    style: {
      fill: "#a3ea2a"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "999.67 39.38 1007.87 38.33 1003.77 236.52 997.46 234.61 999.67 39.38",
    style: {
      fill: "#0f1623"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1088.26,
    cy: 152.73,
    r: 6.59,
    style: {
      fill: "#df0037"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_141",
    "data-name": "Artwork 141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1004.98,186.3c.06-.12.16-.2.28-.23h0c.18-.05.39,0,.51.18l2.28,3.35h0c.2.29,0,.69-.34.71l-4.17.3h0c-.36.02-.6-.35-.44-.67l1.89-3.66h0Z",
    style: {
      fill: "url(#radial-gradient)",
      isolation: "isolate",
      opacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m995.7,160.7c1.93-2.04,4.69-.51,2.93.86-2.74,2.12-3.86,12.03-3.86,12.03-3.34-8.47.94-12.89.94-12.89Z",
    style: {
      fill: "url(#radial-gradient-2)",
      isolation: "isolate",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m988.76,171.59c-.62-8.61,4.29-16.18,11.34-18.2h0c.89-.26,1.82-.42,2.77-.49h0c8.5-.62,15.96,6.75,16.66,16.45h0c.7,9.7-5.61,18.07-14.11,18.69h0c-8.5.62-15.96-6.75-16.66-16.45h0Z",
    style: {
      fill: "url(#radial-gradient-3)",
      isolation: "isolate",
      opacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1010.36,185.82c-2.7-8.7,1.89-12.79,1.89-12.79,2.07-1.9,4.72-.16,2.85,1.08-2.89,1.92-4.74,11.71-4.74,11.71h0Z",
    style: {
      fill: "url(#radial-gradient-4)",
      isolation: "isolate",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1005.71,190.15c-.93,3.62-1.02,7.41-.16,11.06.31,1.31.65,2.95,1.8,3.8s2.88.84,4.28.94c3.66.25,8.53.47,10.53,4.16,1.08,1.99.61,4.25.01,6.31-.56,1.94-1.22,3.85-1.77,5.78-1.2,4.18-2,8.53-.89,12.82.11.44.8.25.68-.19-1.06-4.09-.31-8.23.82-12.22.53-1.87,1.15-3.72,1.71-5.59.51-1.71.98-3.5.71-5.29-.41-2.71-2.66-4.57-5.12-5.48-1.62-.6-3.36-.78-5.07-.91-1.82-.14-4.98.21-6.1-1.58s-1.34-4.42-1.46-6.42c-.14-2.37.11-4.72.7-7.01.11-.44-.57-.63-.68-.19h0Z",
    style: {
      fill: "url(#radial-gradient-5)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m997.42,160.41c1.84-2.12,4.67-.69,2.96.75-2.66,2.23-3.39,12.17-3.39,12.17-3.67-8.34.43-12.92.43-12.92Z",
    style: {
      fill: "url(#radial-gradient-6)",
      isolation: "isolate",
      opacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Artwork_141-2",
    "data-name": "Artwork 141"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1075.05,170.07c.11-.07.24-.08.36-.05h0c.18.05.33.21.34.42l.19,4.05h0c.02.35-.35.59-.66.43l-3.71-1.92h0c-.32-.16-.33-.61-.03-.8l3.52-2.13h0Z",
    style: {
      fill: "url(#radial-gradient-7)",
      isolation: "isolate",
      opacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1080.52,143.4c2.71-.74,4.27,2.02,2.04,2.27-3.45.38-9.58,8.24-9.58,8.24,1.58-8.97,7.54-10.5,7.54-10.5Z",
    style: {
      fill: "url(#radial-gradient-8)",
      isolation: "isolate",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1068.91,149.06c3.97-7.67,12.11-11.55,19.18-9.59h0c.89.25,1.77.59,2.62,1.03h0c7.57,3.92,10.08,14.1,5.61,22.74h0c-4.47,8.64-14.23,12.47-21.8,8.56h0c-7.57-3.92-10.08-14.1-5.61-22.74h0Z",
    style: {
      fill: "url(#radial-gradient-9)",
      isolation: "isolate",
      opacity: 0.95
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1079.89,172.48c2.24-8.82,8.29-9.92,8.29-9.92,2.76-.53,4.1,2.33,1.87,2.41-3.47.12-10.16,7.51-10.16,7.51h0Z",
    style: {
      fill: "url(#radial-gradient-10)",
      isolation: "isolate",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1073.65,173.75c-2.63,2.54-4.64,5.64-5.83,9.1-.49,1.42-1.15,3.19-.43,4.63s2.56,2.46,3.88,3.4c3.3,2.35,7.71,6.24,5.34,10.75-.91,1.74-2.54,3.03-4,4.3-1.37,1.2-2.75,2.39-4.07,3.64-2.86,2.72-5.4,5.81-6.57,9.64-.13.44.55.63.68.19,1.09-3.59,3.44-6.49,6.1-9.06,2.5-2.42,5.62-4.46,7.73-7.24s1.73-6.05-.27-8.75c-1.06-1.43-2.46-2.54-3.89-3.58-1.52-1.11-4.31-2.39-4.53-4.45-.13-1.19.42-2.56.83-3.67.38-1.05.85-2.07,1.38-3.05,1.1-1.99,2.49-3.78,4.13-5.36.33-.32-.17-.82-.5-.5h0Z",
    style: {
      fill: "url(#radial-gradient-11)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1082.14,144.05c2.68-.84,4.34,1.85,2.13,2.18-3.43.51-9.25,8.61-9.25,8.61,1.23-9.02,7.12-10.79,7.12-10.79Z",
    style: {
      fill: "url(#radial-gradient-12)",
      isolation: "isolate",
      opacity: 0.7
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "724.34 83.03 752.69 80.41 751.38 161.11 724.78 153.26 724.34 83.03",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "759.74 76.67 758.65 163.65 798.24 174.85 797.83 73.71 759.74 76.67",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "810.64 67.71 810.2 178.83 861.99 193.88 861.99 63.29 810.64 67.71",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "879.73 53.55 879.7 199.64 952.3 221.33 955.4 46.91 879.73 53.55",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#drop-shadow-3)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 990.69,
    y: 97.46,
    width: 13.08,
    height: 15.17,
    transform: "translate(243.88 -556.75) rotate(35.29)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1003.5,
    y: 105.14,
    width: 13.08,
    height: 15.17,
    transform: "translate(157.55 -440.58) rotate(26.62)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014.48,
    y: 111,
    width: 13.08,
    height: 15.17,
    transform: "translate(91.8 -320.84) rotate(18.68)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1027.28,
    y: 113.93,
    width: 13.08,
    height: 15.17,
    transform: "translate(29.91 -153.64) rotate(8.62)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1053.94,
    y: 114.56,
    width: 13.08,
    height: 15.17,
    transform: "translate(-1.6 229.47) rotate(-12.34)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.81,
    y: 105.88,
    width: 13.08,
    height: 15.17,
    transform: "translate(54.62 471.87) rotate(-25.14)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066.37,
    y: 110.27,
    width: 13.08,
    height: 15.17,
    transform: "translate(22.04 364.25) rotate(-19.46)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1041.19,
    y: 115.39,
    width: 13.08,
    height: 15.17,
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090.59,
    y: 100.02,
    width: 13.08,
    height: 15.17,
    transform: "translate(93.18 562.98) rotate(-30)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1102.3,
    y: 91.97,
    width: 13.08,
    height: 15.17,
    transform: "translate(194.04 734.05) rotate(-39.87)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m988.58,87.89s32.97,33.41,69.43,26.8c36.46-6.61,61.56-35.38,61.56-35.38",
    style: {
      fill: "none",
      stroke: "#223654",
      strokeMiterlimit: 10,
      strokeWidth: "1.46px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(991.24 106.67) rotate(32.22)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1042.92 127.75)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1004.42 114.36) rotate(32.22)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1068.94 123.92) rotate(-19.46)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1057.05 126.97) rotate(-12.34)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1082.98 119.05) rotate(-25.14)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1094.47 113.42) rotate(-25.14)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1015.87 121.71) rotate(18.68)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1108.99 105.36) rotate(-39.87)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "T"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1030.43 126.99) rotate(8.62)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I")))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#drop-shadow-4)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1064.71,
    y: 70.78,
    width: 13.08,
    height: 15.17,
    transform: "translate(13.39 264.53) rotate(-14.16)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1087.03,
    y: 60.9,
    width: 13.08,
    height: 15.17,
    transform: "translate(112.27 555.96) rotate(-30)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1068.96 83.82) rotate(-14.16)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))), /*#__PURE__*/React.createElement("rect", {
    x: 1003.5,
    y: 63.79,
    width: 13.08,
    height: 15.17,
    transform: "translate(171.01 -495.46) rotate(30)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1024.36,
    y: 71.84,
    width: 13.08,
    height: 15.17,
    transform: "translate(58.94 -273.22) rotate(15.54)",
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1044.12,
    y: 74.4,
    width: 13.08,
    height: 15.17,
    style: {
      fill: "#151c2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m989.32,46.91s32.97,33.41,69.43,26.8c36.46-6.61,61.56-35.38,61.56-35.38",
    style: {
      fill: "none",
      stroke: "#223654",
      strokeMiterlimit: 10,
      strokeWidth: "1.46px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1003.24 73.71) rotate(30)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1025.14 83.37) rotate(12.16)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1047.11 86.7)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1092.01 73.83) rotate(-30)",
    style: {
      fill: "#a3ea2a",
      fontFamily: "Skia-Bold, Skia",
      fontSize: "12.95px",
      fontVariationSettings: "&apos",
      fontWeight: 700
    }
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Y"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetiredRoomsBanner);
export default __webpack_public_path__ + "static/media/retired-rooms-banner.91e47bc54f35883c2cfe0ffe6fceaf39.svg";
export { ForwardRef as ReactComponent };